import { restClient } from '../client';
import { AppointmentSlotDuration } from '../resources';


export type GetAvailabilitySlotsForRangeInput = {
  datetime_from: string;
  datetime_to: string;
  provider_id: string;
  patient_id?: string;
  exclude_providers?: string[];
  booking_slot_duration?: AppointmentSlotDuration;
  booking_source?: 'patient_books_directly'; // only one used right now
};


export type GetAvailabilitySlotsForRangeOutput = {
  datetime_from: string;
  datetime_to: string;
  slots: string[];
};


export const getAvailabilitySlotsForRange = restClient.createRequest<GetAvailabilitySlotsForRangeInput, GetAvailabilitySlotsForRangeOutput>({
  url: '/api/v1/availability/slots-for-range',
  method: 'POST',
});
